import { normalizeIntegerMoney } from "components/FormElements/normalizeMoney";

export const normalizeInteger = v => v && `${v}`.replace(/[^\d]/g, "");

export const normalizeIntegerNegativeOrPositive = v => v && `${v}`.replace(/(^-|-\d)|[^0-9]/g, '$1');

export const normalizeIntegerLength = l =>
  (v => normalizeInteger(v).substring(0, l));

//don't pass in decimalPlaces if you would like any amount to be allowed
//max length is only if the number is unformatted
export const normalizeNumberVariableDecimal = (decimalPlaces, unformatted, maxLength) => (value, previousValue) => {
  if (!value && value != 0) {
    return "";
  }

  let idx;
  value = `${value}`.replace(/[^\d.]/g, "");

  //don't let the user type in another decimal point if they are allowed to type decimal points
  //don't let the user type in any decimal points at all if decimalPlaces is 0
  let decimalCount = (value.match(/\./g) || []).length;

  if (previousValue && (decimalCount > 1 || decimalCount > 0 && decimalPlaces === 0)) {
    value = `${previousValue}`.replace(/[^\d.]/g, "");
  }

  //trim leading 0s
  if (!unformatted && value.length > 0) {
    value = value.replace(/^0+/, "");
    if (!value.length) value = "0";
    if (value.substring(0, 1) === ".") value = `0${value}`; // put a leading zero back onto values that less than 1
  }

  if (decimalPlaces === 0) {
    value = value.split(".")[0];//strip everything after the decimal
  } else {
    value = value.split("").reduce((acc, s) => s === "." && acc.indexOf(".") !== -1 ? acc : acc + s, "");
    idx = value.indexOf(".");
    //even tho we check decimalPlaces === 0 above, we still need to check decimalPlaces > 0 here because if decimal places is undefined we support any amount of decimals
    if (idx !== -1 && decimalPlaces > 0) {
      value = value.slice(0, idx + decimalPlaces + 1);
    }
  }

  if (!idx || idx === -1) idx = value.length;

  if (!unformatted) while ((idx -= 3) > 0) value = value.slice(0, idx) + "," + value.slice(idx);

  if (unformatted && maxLength) {
    value = value.slice(0, maxLength);
  }

  return value;
};

export const normalizeIntegerFormatted = v =>  v ? normalizeIntegerMoney(v).substring(1) : null;

//has not been tested to be used as a normalizer (allowing real time typing)
export const formatNumberConsistentDecimalLength = (decimalPlaces = 2, showCommas = true) => n => {
  let [integer, fraction] = parseFloat(n).toFixed(decimalPlaces).split(".");
  if (showCommas) integer = Number(integer).toLocaleString();
  return `${integer}.${fraction}`;
};
